import api from '@api'
import { transformForm } from '@data/form'
import { transformFeedbackSetting } from '@data/feedback'
import {
  transformFeedbackForServer,
  transformTicketForDetail,
} from '@data/ticket'
import { transformConversation } from '@data/conversation'
import moduleConfig from './config'

import {
  getRootTranslator,
  getModuleTranslator,
} from '@utils/get-module-translator'

const __t = getModuleTranslator(moduleConfig.translationKey)
const __rootT = getRootTranslator()

const transformRequest = (request) => ({
  id: request.id,
  subject: request.subject,
  name: request.name,
  createdAt: request.createdTime,
  statusId: request.statusId,
  sourceId: request.sourceId,
  rating: request.feedbackRating,
  resolvedAt: request.lastResolvedTime,
  createdBy: request.createdById,
  requesterName: request.requesterName,
  requester: request.requesterId,
  priorityId: request.priorityId,
  urgencyId: request.urgencyId,
  templateId: request.templateId,
  impactId: request.impactId,
  locationId: request.locationId,
  technicianId: request.technicianId,
  groupId: request.groupId,
  categoryId: request.categoryId,
  departmentId: request.departmentId,
  vendorId: request.vendorId,
  ...(request.fieldValueDetails || {}),
  lastResolvedTime: request.lastResolvedTime,
  lastClosedTime: request.lastClosedTime,
  approvalStatus: request.approvalStatus,
})

const transformChange = (change) => ({
  id: change.id,
  name: change.name,
  subject: change.subject,
  createdAt: change.createdTime,
  assignee: change.technicianId,
  statusId: change.statusId,
  priorityId: change.priorityId,
  changeTypeId: change.changeTypeId,
  riskTypeId: change.riskTypeId,
  approvalStatus: change.approvalStatus,
})

export function getMyRequestsApi(qualifications, limit, offset) {
  return api
    .post(
      '/cportal/myRequest/search/byqual',
      {
        ...(qualifications ? { qualDetails: qualifications } : {}),
      },
      {
        params: {
          offset: offset || 0,
          size: limit === undefined ? 1000 : limit,
        },
        notify: false,
      }
    )
    .then((data) => {
      return {
        items: (data.objectList || []).map(transformRequest),
        total: data.totalCount,
      }
    })
}

export function getFeedbackForm() {
  return api
    .get('/module/feedback/form', {
      notify: false,
    })
    .then(transformForm)
}

export function sendFeedbackForm(id, data) {
  return api.post(
    `/cportal/request/${id}/feedback`,
    transformFeedbackForServer(data),
    {
      notification: {
        error: {
          message: __rootT('error'),
        },
      },
    }
  )
}

export function resetPasswordApi(data) {
  return api.post('/public/selfservice/reset_password', data, {
    notification: {
      message: __rootT('success'),
      description: __t('password_reset_success'),
      error: {
        message: __rootT('error'),
      },
    },
  })
}

export function unlockAccountApi(email) {
  return api.post('/public/selfservice/unlock_account', email, {
    notification: {
      message: __t('success'),
      description: __t('account_unlocked'),
      error: {
        message: __rootT('error'),
      },
    },
  })
}

export function validateAnswerApi(question, answer, email, selfServiceType) {
  return api.post(
    '/public/selfservice/question/verify',
    {
      questionToVerify: { key: question, value: answer },
      email: email,
      selfServiceType: selfServiceType,
    },
    {
      notification: {
        error: {
          message: __rootT('error'),
        },
      },
    }
  )
}

export function validateUserApi(data) {
  return api.post('/public/selfservice/user/validate', data, {
    notification: {
      error: {
        message: __rootT('error'),
      },
    },
  })
}

export function getFeedbackSettings() {
  return api.get('/feedbacksetting').then(transformFeedbackSetting)
}

export function getLatestFeedback(moduleName, requestId, limit, offset) {
  return api
    .get(`/cportal/${moduleName}/${requestId}/allfeedbacks`, {
      params: {
        offset: offset || 0,
        size: limit === undefined ? 1000 : limit,
      },
      notify: false,
    })
    .then((data) => {
      return {
        items: (data.objectList || []).map(transformConversation),
        total: data.totalCount,
      }
    })
}

export function getMyChangesApi(qualifications, limit, offset) {
  return api
    .post(
      '/cportal/myChanges/search/byqual',
      {
        ...(qualifications ? { qualDetails: qualifications } : {}),
      },
      {
        params: {
          offset: offset || 0,
          size: limit === undefined ? 1000 : limit,
        },
        notify: false,
      }
    )
    .then((data) => {
      return {
        items: (data.objectList || []).map(transformChange),
        total: data.totalCount,
      }
    })
}

export function getChangeDetailsApi(id) {
  return api.get(`/cportal/change/${id}`).then(transformTicketForDetail)
}

export function getPendingFeedbackCountApi() {
  return api.get(`/request/pendingfeedbackcount`)
}
